import React, { useContext, useEffect, useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import AddBtn from 'components/AddBtn';
// import FilterUsers from 'components/FilterUsers';
import { UseTranslationProps } from 'types/UseTranslationProps';
import TitleNavBarContext from 'context/TitleNavBarContext';
import SystemNotifyContext from 'context/SystemNotifyContext';
import ListUsers from 'components/ListUsers';
import Pagination from 'components/Pagination';
import FormUser from 'components/FormUser';
import { UserMondelezProps } from 'types/UserProps';
import { getUsers } from './reqs';
import RolesUserContext from 'context/RolesUserContext';
import {
	canAcessAdminPanel,
	getObjOnLocalStorage,
	getRoles,
	removeSpecialCharacters
} from 'utils/functions';
import FilterUsers from 'components/FilterUsers';
import { FiltersUsersProps } from 'types/FiltersUsersProps';

export default function Users() {
	const userData: UserMondelezProps = getObjOnLocalStorage();
	const canAcess = canAcessAdminPanel(userData?.authentication?.roles || []);

	const { i18n, t }: UseTranslationProps = useTranslation();
	const { setDataAbouTitle } = useContext(TitleNavBarContext);
	const { handleNotify } = useContext(SystemNotifyContext);
	const { listRoles, isSearchingRoles, setIsSearchingRoles, setListRoles } =
		useContext(RolesUserContext);

	const [filters, setFilters] = useState<FiltersUsersProps>({
		filterByEmail: '',
		filterByCpf: '',
		justUsersAllowed: true
	});
	const [justUsersAllowed, setJustUsersAllowed] = useState(true);
	const [page, setPage] = useState(1);
	const [qtdPages, setQtdPages] = useState(1);
	const [isFormOpen, setIsFormOpen] = useState(false);
	const [isReq, setIsReq] = useState(false);
	const [userToEdit, setUserToEdit] = useState<null | UserMondelezProps>(null);
	const [listUsers, setListUsers] = useState<UserMondelezProps[]>([]);

	useEffect(() => {
		(async () => {
			setIsReq(true);
			await getUsers(
				{
					filterByCpf: removeSpecialCharacters(filters.filterByCpf),
					filterByEmail: filters.filterByEmail,
					justUsersAllowed: justUsersAllowed
				},
				page,
				setListUsers,
				setQtdPages,
				handleNotify
			);
			setIsReq(false);

			if (page === 0) {
				setPage(1);
			}
		})();
	}, [page]);

	//se não tiver roles, busca as roles
	// isso é necessário para que o usuário possa criar um novo usuário
	useEffect(() => {
		(async () => {
			if (!isSearchingRoles && listRoles.length === 0) {
				await getRoles(setIsSearchingRoles, setListRoles, handleNotify);
			}
		})();
	}, []);

	//muda titulo do componente
	useLayoutEffect(() => {
		setDataAbouTitle((value) => ({ ...value, title: 'navBarOptions.users' }));
	}, [i18n?.language]);

	return (
		<S.container>
			{canAcess && listRoles.length > 0 && (
				<AddBtn
					text={t('users.newUser')}
					anyFunction={() => {
						setIsFormOpen(true);
					}}
				/>
			)}

			<FilterUsers
				filters={filters}
				setFilters={setFilters}
				setListUsers={setListUsers}
				page={page}
				setPage={setPage}
				setQtdPages={setQtdPages}
				justUsersAllowed={justUsersAllowed}
				setJustUsersAllowed={setJustUsersAllowed}
			/>

			<ListUsers
				page={page}
				filters={filters}
				justUsersAllowed={justUsersAllowed}
				setQtdPages={setQtdPages}
				setIsOpen={setIsFormOpen}
				setUserToEdit={setUserToEdit}
				listUsers={listUsers}
				setListUsers={setListUsers}
				isReq={isReq}
			/>

			<Pagination
				qtdPages={qtdPages}
				getActualPage={setPage}
				actualPage={page}
			/>

			{isFormOpen && (
				<FormUser
					page={page}
					setQtdPages={setQtdPages}
					isOpen={isFormOpen}
					setIsOpen={setIsFormOpen}
					setUserToEdit={setUserToEdit}
					userToEdit={userToEdit}
					setListUsers={setListUsers}
					filters={filters}
					justUsersAllowed={justUsersAllowed}
				/>
			)}
		</S.container>
	);
}
